module.exports = __webpack_public_path__ + "img/me.2aade05d.jpg";